import 'reflect-metadata';
import {Container} from 'inversify';
import {httpApi} from '../../common/infra/http';
import { VerifyUseCase, VerifyBatchUseCase, GetServiceInfoUseCase } from '../application/verify.use.case';
import { ValidateCataGadpHttpGateway } from './validateCataGadp.http.gateway';

export const Registry = {
    AxiosAdapter: Symbol.for('AxiosAdapter'),
    ValidateCataGadpGateway: Symbol.for('ValidateCataGadpGateway'),
    VerifyUseCase: Symbol.for('VerifyUseCase'),
    VerifyBatchUseCase: Symbol.for('VerifyBatchUseCase'),
    GetServiceInfoUseCase: Symbol.for('GetServiceInfoUseCase'),
};

export const container = new Container();

//########## HTTP
container.bind(Registry.AxiosAdapter).toConstantValue(httpApi);

//#region ########## GATEWAYS
container.bind(Registry.ValidateCataGadpGateway).toDynamicValue((context) => {
    return new ValidateCataGadpHttpGateway(context.container.get(Registry.AxiosAdapter));
});

//#endregion

//#region ########## USE CASES
container.bind(Registry.VerifyUseCase).toDynamicValue((context) => {
    return new VerifyUseCase(context.container.get(Registry.ValidateCataGadpGateway));
});

container.bind(Registry.VerifyBatchUseCase).toDynamicValue((context) => {
    return new VerifyBatchUseCase(context.container.get(Registry.ValidateCataGadpGateway));
});

container.bind(Registry.GetServiceInfoUseCase).toDynamicValue((context) => {
    return new GetServiceInfoUseCase(context.container.get(Registry.ValidateCataGadpGateway));
});

//#endregion

//#region ######### CONTAINERS GET
const verifyCataGadp = {
    verify: container.get<VerifyUseCase>(Registry.VerifyUseCase),
    verifyBatch: container.get<VerifyBatchUseCase>(Registry.VerifyBatchUseCase),
    getServiceInfo: container.get<GetServiceInfoUseCase>(Registry.GetServiceInfoUseCase),
};
export default verifyCataGadp;
//#endregion
